import script from "./UserStatisticChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserStatisticChart.vue?vue&type=script&setup=true&lang=ts"

import "./UserStatisticChart.vue?vue&type=style&index=0&id=ef75b352&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef75b352"]])

export default __exports__